var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticClass:"icon icon--down-arrow",class:_vm.props.classes,attrs:{"fill":_vm.props.fill,"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }